import type { TrackStatus } from "@engine/round/aggregate";
import { assertUnreachable } from "@lib/utils/assertUnreachable";

/**
 * Maps round status codes to user-friendly display names
 */
export const getRoundStatusDisplayName = (status: TrackStatus): string => {
  const statusMap: Record<TrackStatus, string> = {
    "1.onboarding": "Onboarding",
    "2.initial-evaluations": "Initial Evaluations",
    "3.full-discussion": "Full Discussion",
    "4.evals-freeze": "Evals Freeze",
    "5.complete": "Complete",
  };

  return statusMap[status] || status;
};

export const allPhases: TrackStatus[] = [
  "1.onboarding",
  "2.initial-evaluations",
  "3.full-discussion",
  "4.evals-freeze",
  "5.complete",
];

export type NavItemLabel =
  | "Onboarding"
  | "Recusals"
  | "Investigations"
  | "Proposals"
  | "Others' Evaluations"
  | "Analysis";

export function accessiblePhases(
  label: NavItemLabel,
  isUserFunder: boolean,
): TrackStatus[] {
  switch (label) {
    case "Onboarding":
      return ["1.onboarding", "2.initial-evaluations", "3.full-discussion"];
    case "Recusals":
      return [
        "2.initial-evaluations",
        "3.full-discussion",
        ...(isUserFunder ? (["4.evals-freeze"] as const) : []),
      ];
    case "Investigations":
      return [
        "2.initial-evaluations",
        "3.full-discussion",
        ...(isUserFunder ? (["4.evals-freeze"] as const) : []),
      ];
    case "Proposals":
      return [
        "1.onboarding",
        "2.initial-evaluations",
        "3.full-discussion",
        "4.evals-freeze",
        "5.complete",
      ];
    case "Others' Evaluations":
      return [
        ...(isUserFunder ? (["2.initial-evaluations"] as const) : []),
        "3.full-discussion",
        "4.evals-freeze",
        "5.complete",
      ];
    case "Analysis":
      return [
        ...(isUserFunder ? (["2.initial-evaluations"] as const) : []),
        "3.full-discussion",
        "4.evals-freeze",
        "5.complete",
      ];
    default:
      assertUnreachable(label);
  }
}
